import { render, staticRenderFns } from "./report-gaoxueya.vue?vue&type=template&id=f77285ec&scoped=true&"
import script from "./report-gaoxueya.vue?vue&type=script&lang=ts&"
export * from "./report-gaoxueya.vue?vue&type=script&lang=ts&"
import style0 from "./report-gaoxueya.vue?vue&type=style&index=0&id=f77285ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77285ec",
  null
  
)

export default component.exports